import { makeModuleStateSelector } from "@client/content/selectors";
import { defaultState, previewState } from "./reducer";
import type { BlogDetailContent } from "./types";

export const localStateSelector = makeModuleStateSelector<BlogDetailContent.State>(defaultState, previewState);
